// Shared helpers for public site pages
export function cloudinaryThumb(url, transform = "c_fill,w_800,q_auto,f_auto") {
  if (!url || typeof url !== "string") return url;
  if (!url.includes("/upload/")) return url;
  // Avoid double-injecting transformations
  if (/\/upload\/[a-z0-9_,]+\//.test(url) && url.match(/\/upload\/(c_|w_|q_|f_|h_)/)) return url;
  return url.replace("/upload/", `/upload/${transform}/`);
}

// Pick the best image to show for a car — uploaded photo if any, else null
// (consumers should show a "Billeder på vej" text-placeholder instead of an image).
export function carDisplayImage(car, transform = "c_fill,w_800,q_auto,f_auto") {
  const uploaded = car?.public_photos?.[0]?.url;
  if (uploaded) return cloudinaryThumb(uploaded, transform);
  return null;
}

// Indicator: does this car have at least one uploaded photo?
export function hasUploadedPhotos(car) {
  return Array.isArray(car?.public_photos) && car.public_photos.length > 0 && !!car.public_photos[0]?.url;
}

export function dkk(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("da-DK", { style: "currency", currency: "DKK", maximumFractionDigits: 0 }).format(n);
}

export function plain(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("da-DK").format(n);
}

export function daysBetween(start, end) {
  if (!start || !end) return 0;
  const a = new Date(start);
  const b = new Date(end);
  const d = Math.round((b - a) / (1000 * 60 * 60 * 24));
  return d > 0 ? d : 0;
}
